import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Helper } from "@utils/index";

const AUTO_LOGOUT_TIME = 30 * 60 * 1000; // 30 minutes

const useAutoLogout = () => {
  const dispatch = useDispatch();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    // Check if user is logged in before setting timer
    const user = Helper.getUser();
    if (user?.id) {
      timerRef.current = setTimeout(() => {
        console.info("[Auth] Auto-logout triggered due to inactivity.");
        Helper.logout(dispatch);
      }, AUTO_LOGOUT_TIME);
    }
  };

  useEffect(() => {
    const events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];
    
    const handleActivity = () => resetTimer();

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    resetTimer();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, []);
};

export default useAutoLogout;
